import { useState } from "react";
import { motion } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { AppSidebar } from "./AppSidebar";
import { TopBar } from "./TopBar";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { WelcomeNudge } from "@/components/tour/WelcomeNudge";
import { useRole } from "@/contexts/RoleContext";
import { getImpersonationData } from "@/utils/clientUtils";

const getBreadcrumbs = (pathname: string): string[] => {
  const parts = pathname.split("/").filter(Boolean);
  return ["Home", ...parts.map(p => p.charAt(0).toUpperCase() + p.slice(1).replace(/-/g, ' '))];
};

export function DashboardLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { role } = useRole();
  const breadcrumbs = getBreadcrumbs(location.pathname);
  const isImpersonating = !!getImpersonationData();

  return (
    <>
      <ImpersonationBanner />
      <WelcomeNudge />
    <div className={`min-h-screen bg-background ${isImpersonating ? 'pt-10' : ''}`}>
      <AppSidebar 
        collapsed={sidebarCollapsed} 
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      
      {/* Mobile Header */}
      <div className="md:hidden fixed top-0 left-0 right-0 h-14 bg-background border-b border-border z-40 flex items-center px-4">
        <button
          onClick={() => setMobileOpen(true)}
          className="p-2 rounded-lg hover:bg-accent transition-colors"
        >
          <Menu className="w-6 h-6" />
        </button>
        <span className="ml-3 font-bold text-lg bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          Venture Hills
        </span>
      </div>

      
      <motion.main
        className="min-h-screen pt-14 md:pt-0 max-md:!ml-0"
        initial={false}
        animate={{ marginLeft: sidebarCollapsed ? 72 : 240 }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        <div className="hidden md:block">
          <TopBar breadcrumbs={breadcrumbs} />
        </div>
        
        <div className="p-4 md:p-6">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </div>
      </motion.main>
    </div>
    </>
  );
}
